import { render, staticRenderFns } from "./is_test.vue?vue&type=template&id=946f1016&scoped=true&"
import script from "./is_test.vue?vue&type=script&lang=js&"
export * from "./is_test.vue?vue&type=script&lang=js&"
import style0 from "./is_test.vue?vue&type=style&index=0&id=946f1016&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946f1016",
  null
  
)

export default component.exports